export default {
  nav: {
    home: "होम", about: "हमारे बारे में", services: "सेवाएँ", countries: "देश",
    why: "हमें क्यों चुनें", stories: "सफलता की कहानियाँ", faq: "सामान्य प्रश्न", blog: "ब्लॉग", contact: "संपर्क",
    consultation: "निःशुल्क परामर्श", call: "अभी कॉल करें", whatsapp: "व्हाट्सऐप",
  },
  hero: {
    eyebrow: "इमिग्रेशन और वीज़ा कंसल्टेंसी — पंजाब, भारत",
    title1: "आपकी यात्रा", title2: "यहीं से शुरू",
    sub: "आपके वैश्विक भविष्य के लिए पेशेवर इमिग्रेशन और वीज़ा सहायता",
    desc: "वर्क परमिट, विज़िटर वीज़ा, इमिग्रेशन दस्तावेज़ों और आवेदन सहायता के लिए पेशेवर मार्गदर्शन के साथ अंतरराष्ट्रीय अवसर तलाशें।",
    cta1: "निःशुल्क परामर्श लें", cta2: "अपनी पात्रता जाँचें",
    trust: ["पेशेवर मार्गदर्शन", "व्यक्तिगत सहायता", "पारदर्शी प्रक्रिया"],
  },
  enquiry: {
    eyebrow: "निःशुल्क परामर्श",
    title: "आज ही अपनी वीज़ा यात्रा शुरू करें",
    desc: "कुछ विवरण साझा करें — हमारी टीम आपके लक्ष्यों और आगे की राह पर चर्चा करने के लिए संपर्क करेगी।",
    name: "पूरा नाम", phone: "फ़ोन नंबर", email: "ईमेल पता", city: "शहर",
    visaType: "वीज़ा प्रकार", country: "पसंदीदा देश", message: "संदेश",
    submit: "पूछताछ भेजें", submitting: "भेजा जा रहा है...",
    successTitle: "आपकी पूछताछ के लिए धन्यवाद।",
    successText: "आपके विवरण THE TRIP WORLD को प्राप्त हो गए हैं। श्री धीरज कटारिया की टीम शीघ्र ही आपसे संपर्क करके निःशुल्क परामर्श का समय तय करेगी।",
    another: "एक और पूछताछ भेजें",
  },
  about: {
    eyebrow: "01 — हम कौन हैं",
    title1: "आपकी यात्रा.", title2: "हमारा मार्गदर्शन.",
    p1: "THE TRIP WORLD अहमदगढ़, पंजाब में स्थित एक पेशेवर इमिग्रेशन और वीज़ा कंसल्टेंसी है। हम अंतरराष्ट्रीय यात्रा, कार्य, अध्ययन और इमिग्रेशन के अवसर तलाशने वाले व्यक्तियों और परिवारों के साथ काम करते हैं।",
    p2: "हमारी टीम व्यक्तिगत परामर्श, दस्तावेज़ मार्गदर्शन और आवेदन सहायता प्रदान करती है — ईमानदार सलाह, सुव्यवस्थित प्रक्रिया और हर कदम पर स्पष्ट संवाद के साथ।",
    quote: "हर यात्रा सही मार्गदर्शन से शुरू होती है। हमारी भूमिका आपकी आवेदन प्रक्रिया को स्पष्ट, सुव्यवस्थित और तनाव-मुक्त बनाना है।",
    founder: "श्री धीरज कटारिया", founderRole: "संस्थापक, THE TRIP WORLD",
    learnMore: "और जानें",
  },
  services: {
    eyebrow: "02 — हम क्या करते हैं", title: "हमारी सेवाएँ",
    desc: "आपके गंतव्य और लक्ष्यों के अनुसार संपूर्ण वीज़ा और इमिग्रेशन सहायता।",
    learnMore: "और जानें",
  },
  countries: {
    eyebrow: "03 — गंतव्य", title: "अपना वैश्विक गंतव्य चुनें",
    desc: "कनाडा से लेकर UAE तक — जानें किन रास्तों की तैयारी में हम आपकी मदद कर सकते हैं।",
    explore: "जानें",
    names: {
      canada: "कनाडा", "united-kingdom": "यूनाइटेड किंगडम", australia: "ऑस्ट्रेलिया",
      usa: "अमेरिका", "new-zealand": "न्यूज़ीलैंड", europe: "यूरोप (शेंगेन)",
      germany: "जर्मनी", france: "फ्रांस", uae: "यूएई",
    },
    blurbs: {
      canada: "स्किल्ड वर्कर्स, छात्रों और परिवारों के लिए अग्रणी गंतव्य।",
      "united-kingdom": "विश्व-स्तरीय विश्वविद्यालय और वैश्विक करियर के अवसर।",
      australia: "शिक्षा, कार्य और यात्रा के लिए एक जीवंत गंतव्य।",
      usa: "अमेरिका में व्यापार, पर्यटन और शिक्षा।",
      "new-zealand": "बेहतरीन शिक्षा और कार्य विकल्पों के साथ मनोरम वादियाँ।",
      europe: "शेंगेन वीज़ा पर कई यूरोपीय देशों की यात्रा करें।",
      germany: "कार्य और अध्ययन के लिए यूरोप की आर्थिक शक्ति।",
      france: "यूरोप के दिल में संस्कृति, शिक्षा और व्यापार।",
      uae: "करियर, व्यापार और पर्यटन का वैश्विक केंद्र।",
    },
  },
  why: {
    eyebrow: "04 — हमारी खासियत", title: "THE TRIP WORLD ही क्यों?",
    desc: "ईमानदारी, व्यवस्था और सच्ची ग्राहक-देखभाल पर आधारित कंसल्टेंसी अनुभव।",
    items: [
      { title: "व्यक्तिगत मार्गदर्शन", text: "हर आवेदक की परिस्थितियों, लक्ष्यों और यात्रा इतिहास के अनुसार मार्गदर्शन।" },
      { title: "दस्तावेज़ सहायता", text: "आवेदन दस्तावेज़ों को व्यवस्थित करने में पेशेवर सहायता।" },
      { title: "पारदर्शी संवाद", text: "आवश्यकताओं और आवेदन चरणों की स्पष्ट जानकारी।" },
      { title: "पेशेवर दृष्टिकोण", text: "शुरू से अंत तक सुव्यवस्थित और संगठित परामर्श प्रक्रिया।" },
      { title: "संपूर्ण सहायता", text: "आवेदन के हर संबंधित चरण में सहायता।" },
      { title: "ग्राहक-केंद्रित", text: "हर आवेदक के लक्ष्यों के अनुसार बनाया गया परामर्श अनुभव।" },
    ],
  },
  process: {
    eyebrow: "05 — प्रक्रिया", title: "आगे का स्पष्ट रास्ता",
    desc: "पहली बातचीत से आवेदन सहायता तक — चार सुव्यवस्थित चरण।",
    items: [
      { title: "परामर्श", text: "हमारी टीम के साथ अपने यात्रा या इमिग्रेशन लक्ष्यों पर चर्चा करें।" },
      { title: "प्रोफ़ाइल और दस्तावेज़ समीक्षा", text: "बुनियादी जानकारी और दस्तावेज़ आवश्यकताओं की समीक्षा।" },
      { title: "आवेदन तैयारी", text: "आवश्यक दस्तावेज़ तैयार और व्यवस्थित करें।" },
      { title: "आवेदन सहायता", text: "लागू आवेदन प्रक्रिया में मार्गदर्शन।" },
    ],
  },
  eligibility: {
    eyebrow: "06 — पात्रता", title: "अपनी वीज़ा पात्रता जाँचें",
    desc: "अपनी प्रोफ़ाइल और लक्ष्य बताएं — हमारी टीम आपके विवरण की समीक्षा कर उपयुक्त अगले कदम बताएगी।",
    name: "नाम", age: "उम्र", phone: "फ़ोन", email: "ईमेल", education: "शिक्षा",
    occupation: "पेशा", experience: "कार्य अनुभव", country: "पसंदीदा देश",
    visaType: "वीज़ा प्रकार", english: "IELTS / PTE स्थिति", message: "संदेश (वैकल्पिक)",
    submit: "पात्रता जाँचें", submitting: "जाँच हो रही है...",
    disclaimer: "यह केवल प्रारंभिक मूल्यांकन है। अंतिम वीज़ा निर्णय संबंधित इमिग्रेशन प्राधिकरण लेता है और पात्रता वीज़ा स्वीकृति की गारंटी नहीं देती।",
    successTitle: "प्रोफ़ाइल प्राप्त हुई।",
    successText: "धन्यवाद। हमारी टीम आपके विवरण की समीक्षा कर पात्रता और अगले कदमों पर चर्चा के लिए संपर्क करेगी।",
  },
  stories: {
    eyebrow: "07 — सफलता की कहानियाँ", title: "जिन यात्राओं का हमने मार्गदर्शन किया",
    desc: "उन ग्राहकों के सच्चे अनुभव जिन्होंने अपने आवेदनों के लिए THE TRIP WORLD पर भरोसा किया।",
    placeholderTitle: "सच्ची कहानियाँ, जल्द आ रही हैं।",
    placeholderText: "हम केवल वास्तविक ग्राहक अनुभव प्रकाशित करते हैं — असली नाम, गंतव्य और वीज़ा श्रेणी के साथ। जैसे-जैसे हमारे ग्राहक अपनी यात्राएँ साझा करेंगे, उनकी कहानियाँ यहाँ दिखेंगी।",
  },
  stats: {
    clients: "सहायता प्राप्त ग्राहक", applications: "समर्थित आवेदन",
    destinations: "गंतव्य", years: "वर्षों का अनुभव",
  },
  docs: {
    eyebrow: "08 — तैयार रहें", title: "आपको किन दस्तावेज़ों की ज़रूरत हो सकती है",
    desc: "वीज़ा आवेदनों में आम तौर पर ज़रूरी दस्तावेज़ों का सामान्य परिचय।",
    note: "आवश्यकताएँ देश, वीज़ा श्रेणी और व्यक्तिगत परिस्थितियों के अनुसार अलग होती हैं।",
    items: [
      { title: "पासपोर्ट", text: "पर्याप्त वैधता और खाली पन्नों वाला पासपोर्ट।" },
      { title: "फ़ोटोग्राफ़", text: "गंतव्य देश के मानकों के अनुरूप हालिया फ़ोटो।" },
      { title: "वित्तीय दस्तावेज़", text: "बैंक स्टेटमेंट और धन का प्रमाण (जैसा लागू हो)।" },
      { title: "शैक्षिक दस्तावेज़", text: "डिग्रियाँ, डिप्लोमा और शैक्षणिक ट्रांसक्रिप्ट।" },
      { title: "रोज़गार दस्तावेज़", text: "अनुभव पत्र, ऑफ़र और नियोक्ता रिकॉर्ड।" },
      { title: "यात्रा इतिहास", text: "पिछले वीज़ा और अंतरराष्ट्रीय यात्रा रिकॉर्ड।" },
      { title: "आमंत्रण / सहायक दस्तावेज़", text: "आमंत्रण, प्रायोजन या नामांकन पत्र।" },
      { title: "अन्य सहायक दस्तावेज़", text: "श्रेणी-विशिष्ट दस्तावेज़, जैसा आवश्यक हो।" },
    ],
  },
  faq: {
    eyebrow: "09 — प्रश्न", title: "अक्सर पूछे जाने वाले प्रश्न",
    desc: "हमसे सबसे अधिक पूछे जाने वाले सवालों के सीधे जवाब।",
    items: [
      { q: "THE TRIP WORLD कौन-सी वीज़ा सेवाएँ देता है?", a: "हम वर्क परमिट, विज़िटर, स्टूडेंट, फैमिली/स्पाउज़ और बिज़नेस वीज़ा के लिए परामर्श और आवेदन सहायता देते हैं, साथ ही अंतरराष्ट्रीय यात्रा और इमिग्रेशन हेतु संपूर्ण दस्तावेज़ सहायता भी।" },
      { q: "मैं अपना वीज़ा आवेदन कैसे शुरू करूँ?", a: "निःशुल्क परामर्श से शुरुआत करें। अपना लक्ष्य बताएं — हमारी टीम आपकी प्रोफ़ाइल देखकर सामान्य आवश्यकताएँ और आपके लिए उपयुक्त कदम बताएगी।" },
      { q: "आम तौर पर कौन-से दस्तावेज़ चाहिए होते हैं?", a: "सामान्य दस्तावेज़ों में वैध पासपोर्ट, फ़ोटो, वित्तीय रिकॉर्ड, शैक्षिक और रोज़गार दस्तावेज़ तथा यात्रा इतिहास शामिल हैं। सटीक आवश्यकताएँ देश, वीज़ा श्रेणी और परिस्थितियों पर निर्भर करती हैं।" },
      { q: "वीज़ा प्रोसेसिंग में कितना समय लगता है?", a: "प्रोसेसिंग समय संबंधित इमिग्रेशन प्राधिकरण तय करता है और यह देश, वीज़ा श्रेणी और आवेदनों की संख्या पर निर्भर करता है। परामर्श के दौरान हम मौजूदा अनुमानित समय साझा करते हैं।" },
      { q: "क्या आप मेरे दस्तावेज़ तैयार करने में मदद कर सकते हैं?", a: "हाँ। दस्तावेज़ और आवेदन सहायता हमारी मुख्य सेवाओं में से एक है। हम आपके दस्तावेज़ों को व्यवस्थित करने, समीक्षा करने और स्पष्ट, पूर्ण आवेदन फ़ाइल तैयार करने में मदद करते हैं।" },
      { q: "क्या आप मेरी पात्रता जाँच सकते हैं?", a: "हाँ। हमारा ऑनलाइन पात्रता परीक्षक इस्तेमाल करें या परामर्श बुक करें। ध्यान दें — यह केवल प्रारंभिक मूल्यांकन है; अंतिम पात्रता और वीज़ा निर्णय संबंधित इमिग्रेशन प्राधिकरण लेता है।" },
      { q: "आप किन देशों के लिए सहायता करते हैं?", a: "हम कनाडा, यूके, ऑस्ट्रेलिया, अमेरिका, न्यूज़ीलैंड, यूरोप (शेंगेन), जर्मनी, फ्रांस और UAE के आवेदनों में सहायता करते हैं, तथा अनुरोध पर अन्य गंतव्यों के लिए भी।" },
      { q: "क्या THE TRIP WORLD वीज़ा स्वीकृति की गारंटी देता है?", a: "नहीं। वीज़ा निर्णय पूरी तरह संबंधित इमिग्रेशन प्राधिकरण लेता है और कोई भी कंसल्टेंसी स्वीकृति की गारंटी नहीं दे सकती। हम ईमानदार मार्गदर्शन और पेशेवर आवेदन सहायता देते हैं ताकि आपका मामला स्पष्ट रूप से प्रस्तुत हो।" },
    ],
  },
  blog: {
    eyebrow: "10 — जर्नल", title: "जानकारी और अपडेट",
    desc: "हमारी कंसल्टेंसी टीम की ओर से गाइड, दस्तावेज़ सलाह और यात्रा जानकारी।",
    viewAll: "सभी लेख देखें", read: "लेख पढ़ें",
    emptyTitle: "लेख जल्द आ रहे हैं।",
    emptyText: "हमारे जर्नल में वीज़ा मार्गदर्शन, दस्तावेज़ सुझाव और गंतव्य जानकारी होगी — हमारी अपनी टीम द्वारा प्रकाशित।",
  },
  contact: {
    eyebrow: "11 — संपर्क करें", title: "आइए आपकी यात्रा शुरू करें",
    desc: "हमसे मिलें, कॉल करें या संदेश भेजें — आपका निःशुल्क परामर्श बस एक कदम दूर है।",
    phone: "फ़ोन", emailLabel: "ईमेल", website: "वेबसाइट", location: "पता",
    call: "कॉल करें", whatsapp: "व्हाट्सऐप", emailBtn: "ईमेल",
    formName: "पूरा नाम", formPhone: "फ़ोन नंबर", formEmail: "ईमेल पता",
    formMessage: "हम आपकी कैसे मदद कर सकते हैं?", submit: "संदेश भेजें", sending: "भेजा जा रहा है...",
    successTitle: "संदेश प्राप्त हुआ।",
    successText: "संपर्क करने के लिए धन्यवाद। हमारी टीम जल्द से जल्द आपको जवाब देगी।",
    another: "एक और संदेश भेजें",
  },
  cta: {
    title: "शुरू करने के लिए तैयार हैं?", heading: "आपकी यात्रा यहीं से शुरू",
    text: "THE TRIP WORLD के साथ निःशुल्क परामर्श बुक करें और अपनी वीज़ा यात्रा के लिए स्पष्ट, ईमानदार मार्गदर्शन पाएं।",
    button: "निःशुल्क परामर्श लें",
  },
  footer: {
    blurb: "अहमदगढ़, पंजाब स्थित पेशेवर इमिग्रेशन और वीज़ा कंसल्टेंसी — अंतरराष्ट्रीय कार्य, अध्ययन और यात्रा के अवसरों की ओर आपकी यात्रा का मार्गदर्शन।",
    company: "कंपनी", servicesCol: "सेवाएँ", quick: "त्वरित लिंक", contactCol: "संपर्क",
    eligibility: "पात्रता",
    rights: "सर्वाधिकार सुरक्षित।",
    privacy: "गोपनीयता नीति", terms: "नियम और शर्तें", disclaimerLink: "अस्वीकरण",
  },
  notFound: {
    eyebrow: "रास्ता भटक गए", title: "यह गंतव्य मौजूद नहीं है।",
    text: "आप जो पेज खोज रहे हैं वह हट गया है या कभी था ही नहीं। आइए हम आपको सही रास्ते पर वापस ले चलें।",
    button: "होम पर वापस जाएं",
  },
};
